import { IconName } from 'Components/UI/Icon/IconClasses';
import { colors } from './tokens';

export interface AiIconDefinition {
  glyph: IconName;
  /** Tamanho do glyph para ficar com a mesma área visual do ícone 16px do Figma. */
  size: number;
  color?: string;
}

const defineIcons = <T extends Record<string, AiIconDefinition>>(icons: T) => icons;

/** Ícones do Figma "Chat IA Web v26" mapeados para o icomoon do projeto. */
export const aiIcons = defineIcons({
  sidebarToggle: { glyph: 'panels2', size: 16 },
  newChat: { glyph: 'newEdit', size: 16 },
  edit: { glyph: 'newEdit', size: 16 },
  menuEdit: { glyph: 'newEdit', size: 16, color: colors.onSurface },
  menuTrash: { glyph: 'emptyExcluir', size: 16, color: colors.onSurface },
  close: { glyph: 'cancelar', size: 11 },
  clear: { glyph: 'cancelar', size: 11, color: colors.onSurfacePlaceholder },
  copy: { glyph: 'copiar', size: 16 },
  thumbsUp: { glyph: 'ThumbsUp', size: 16 },
  thumbsDown: { glyph: 'ThumbsDown', size: 16 },
  specialists: { glyph: 'assistentes', size: 16 },
  expand: { glyph: 'arrowExpand', size: 18 },
  contract: { glyph: 'lessexpand', size: 18 },
  promptCalendar: { glyph: 'calendar', size: 16 },
  promptAlertTriangle: { glyph: 'alertTriangle', size: 16 },
  promptDiscipline: { glyph: 'disciplinaArquitetura', size: 16 },
  promptClock: { glyph: 'relogio', size: 16 },
  search: { glyph: 'buscar', size: 14 },
  searchFocused: { glyph: 'buscar', size: 14, color: colors.primary },
  plus: { glyph: 'adicionar', size: 16 },
  more: { glyph: 'moreActions', size: 16 },
  chevronDown: { glyph: 'expandir', size: 10 },
  dangerAlert: { glyph: 'alerta', size: 16, color: colors.danger },
  messages: { glyph: 'doubleChat', size: 24 }
});

export type AiIconName = keyof typeof aiIcons;
